
import { format, parseISO } from "date-fns";

export const DateFormate = (date, formatOfDate) => {
    try {
        if (!formatOfDate) formatOfDate = "MM/dd/yyyy";
        const dateParsed = parseISO(date);
        const formattedDate = format(dateParsed, formatOfDate);
        return formattedDate;
    } catch {
        return "";
    }
};

let debounceTimer;
export function debounce(callback, delay) {
    if (delay === undefined) delay = 500;

    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
        callback();
    }, delay);
}

export const formatNumber = (num) => {
    return num.toLocaleString();
};

export const getBadge = (contentType, isPrimary) => {
    switch(contentType)
    {
      case 'analyst_reports':
        return (
          <span className={`directions-badge analyst-report${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Analyst Report</span>
          </span>);
          
      case 'update_issues':
        return (
          <span className={`directions-badge analyst-report${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Update Issues</span>
          </span>);

      case 'charts_illustrations':
        return (
          <span className={`directions-badge analyst-report${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Charts &amp; Illustrations</span>
          </span>);

      case 'in_brief':
        return (
          <span className={`directions-badge analyst-report${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">In Brief</span>
          </span>);

      case 'deep_dives':
        return (
          <span className={`directions-badge analyst-report${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Deep Dive</span>
          </span>);

      case 'sidebar':
        return (
          <span className={`directions-badge analyst-report${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Sidebar</span>
          </span>);

      case 'webinars':
        return (
          <span className={`directions-badge webinar${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Webinar</span>
          </span>);

      case 'post':
        return (
          <span className={`directions-badge blog${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Blog</span>
          </span>);

      case 'roadmaps':
        return (
          <span className={`directions-badge roadmap${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Roadmap</span>
          </span>);

      case 'content_groups':
        return (
          <span className={`directions-badge roadmap${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Roadmap</span>
          </span>);

      case 'infographics':
        return (
          <span className={`directions-badge infographic${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Infographic</span>
          </span>);

      case 'podcasts':
        return (
          <span className={`directions-badge podcast${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Podcast</span>
          </span>);

      case 'videos':
        return (
          <span className={`directions-badge webinar${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-text">Video</span>
          </span>);

      case 'kits_collections':
        return (
          <span className={`directions-badge kits-collections${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Kits &amp; Collections</span>
          </span>);

      case 'kits_coll':
        return (
          <span className={`directions-badge kits-collections${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Kits &amp; Collections</span>
          </span>);

      case 'getting_started':
        return (
          <span className={`directions-badge kits-collections${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Kits &amp; Collections</span>
          </span>);

      case 'glossary_entry':
        return (
          <span className={`directions-badge licensing-reference${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Reference</span>
          </span>);

      case 'licensing_glossary_entry':
        return (
          <span className={`directions-badge licensing-reference${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Licensing Reference</span>
          </span>);

      case 'product_glossary_entry':
        return (
          <span className={`directions-badge licensing-reference${isPrimary ? ' primary' : ''}`}>
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Product Reference</span>
          </span>);

      case 'product_family':
        return (
          <span className={`directions-badge`}>
            <span className="directions-badge-text">Product Family</span>
          </span>);

      case 'product':
        return (
          <span className={`directions-badge`}>
            <span className="directions-badge-text">Product</span>
          </span>);

      case 'authors_analysts':
        return (
          <span className={`directions-badge`}>
            <span className="directions-badge-text">Authors &amp; Analysts</span>
          </span>);

      case 'summary_subject_area':
        return (
          <span className={`directions-badge`}>
            <span className="directions-badge-text">Subject Area</span>
          </span>);

      case 'subject_area':
        return (
          <span className={`directions-badge`}>
            <span className="directions-badge-text">Subject Area</span>
          </span>);

      case 'internal_page':
        return (
          <span className={`directions-badge`}>
            <span className="directions-badge-text">Page</span>
          </span>);

      case 'page':
        return (
          <span className={`directions-badge`}>
            <span className="directions-badge-text">Page</span>
          </span>);

      case 'events':
        return (
          <span className={`directions-badge`}>
            <span className="directions-badge-text">Event</span>
          </span>);

      default:
        return (
          <span>Content Type: {contentType}</span>);
    }
  }